/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Security_BodyInputs */

const en_contact_point_security_body = /** @type {(inputs: Contact_Point_Security_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployment is scoped to your data residency and entitlement requirements before anything is ingested.`)
};

/**
* | output |
* | --- |
* | "Deployment is scoped to your data residency and entitlement requirements before anything is ingested." |
*
* @param {Contact_Point_Security_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_security_body = /** @type {((inputs?: Contact_Point_Security_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Security_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_security_body(inputs)
});